import React from 'react'
import Typical from 'react-typical'
import ScrollService from '../../../Utilities/ScrollService'
import "./Profile.css"

import dockerIcon from "../../../../src/img/MyIcons/docker-icon1.png"

export default function Profile() {
  return (
    <div className='profile-container'>
      <div className='profile-parent'>
        <div className='profile-details'>

          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'm <span className="highlighted-text">Florence Omoruyi</span>
            </span>
          </div>

          <div className='colz'>
            <div className='colz-icon'>
              <a href='https://www.linkedin.com/in/florence-omoruyi-0ab9b119a/'>
                <i class="fa fa-linkedin fa-2x"></i>
              </a>
              <a href='https://github.com/Florence-InLineOfSight'>
                <i class="fa fa-github fa-2x"></i>
              </a>             
              <a href='https://hub.docker.com/repository/docker/florenceomoruyi/php-web-app1/general'>
                <img src={dockerIcon} alt="no internet connection"></img>
              </a>
              <a href='https://hub.docker.com/repository/docker/florenceomoruyi/php-web-app1/general'>
                <i class="fa fa-twitter fa-2x"></i>
              </a>
              <a href='https://hub.docker.com/repository/docker/florenceomoruyi/php-web-app1/general'>
                <i class="fa fa-facebook fa-2x"></i>
              </a>
            </div>
          </div>

          <div className="profile-details-role">
            <span className='primary-text'>
              {" "}
              <h1>
                {" "}
                <Typical
                loop={Infinity}
                steps={[
                  "DevOps Engineer ✔",
                  1000,
                  "AWS Cloud Practitioner ✔",
                  1000,
                  "Platform Provider ✔",
                  1000,
                  "Infrastructure Provider ✔",
                  1000,
                  "Pharmacist ✔",
                  1000,
                ]}
                />
              </h1>
              <span className='profile-role-tagline'>
                Implementating Automated, Secure, Scalable and Reliable CI/CD Pipelines and Related Platforms and Infrastructures.
              </span>
            </span>
          </div>
          <div className='profile-options'>
            <div>
              <button
                className='btn primary-btn'
                onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
              >
                {" "}
                Contact Me{" "}
              </button>
            </div>
            <div>
              <a href='FlorenceDevOpsCV.pdf' download="Florence Omoruyi CV/Résumé.pdf">
                <button className='btn highlighted-btn'>Get CV/Résumé</button>
              </a>
            </div>
          </div>
        </div>
        <div className='profile-picture'>
          <div className='profile-picture-background'>

          </div>
        </div>
      </div>
    </div>
  )
}